import(/* webpackMode: "eager" */ "/codebuild/output/src945607980/src/apps/junonkuji/src/app/error.tsx");
